import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('免责声明'),
      "width": 900,
      "destroyOnClose": true
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "notice"
  }, [_vm._v(" " + _vm._s(_vm.t('我们(谷仓)建议您通过公司对公账户收取退费,但如果您需要要指定其它账户收取退费,则请您仔细填写相关收款账号信息,并且请您知愿我们(谷仓)不对您指定的第三方账户承担任何责任,我们(谷仓)向指定第三方账户完成退费后即视为向贵司完成退费,我们不参与您与指定第三方账户的具体交易和结算,由于账户问题导致的任何责任我们(谷仓)概不承担,给我司造成损失的应由贵司承担相应费任。')) + " "), _c('span', {
    staticClass: "underline"
  }, [_vm._v(_vm._s(_vm.t('贵司在此确认，所选退款信息真实、准确、完整。')))]), _c('span', {
    staticClass: "know"
  }, [_vm._v(_vm._s(_vm.t('请贵司充分阅读理解本提示内容,如您有不同意见则请勿选择本退款方式。')))])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "fbu-analyse-name": $t("\u786E\u5B9A")
    },
    on: {
      "click": _vm.handle
    }
  }, [_vm._v(_vm._s(_vm.t('确定')))])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };